import { AufnahmePunktDocument } from '../../data-model';
import { filzLage } from '../filz-tiefen';
import { Abschnitt, abschnitte, auflageStreifen, AuflageStreifen } from './grubenbild-abschnitte';
import { GrubenbildDaten } from './grubenbild-zeichnen';

/** Alles, was aus einem Punkt fuer das Grubenbild gelesen wird. */
export interface GrubenbildStand {
	abs: Abschnitt[];
	auflage: { zeilen: AuflageStreifen[]; gesamt: number; erfasst: boolean };
	/**
	 * Filz (filz-tiefen.ts): um so viel cm ruecken alle genannten Tiefen nach
	 * unten - die Auflage gehoert dann zum Profil, 0 cm liegt an ihrer
	 * Oberkante. 0 ohne Filz.
	 */
	versatz: number;
	/** Fertig fuer `zeichneGrubenbild`. */
	daten: GrubenbildDaten;
}

/**
 * Sammelt EINMAL, was `zeichneGrubenbild` aus einem Punkt braucht - fuer den
 * Reiter „Profilbild" und fuer die Seite im PDF-Export. Vorher stand das nur
 * im Bauteil; ein zweiter Aufrufer haette die Zusammenstellung abschreiben
 * muessen, und zwei Fassungen laufen auseinander.
 *
 * @param datum Der Tag der Aufnahme, schon fertig geschrieben („12.06.2026"),
 *   oder nichts. Er steht an der Zeile des Wasserstands; im Gastmodus bleibt
 *   er weg, denn dort ist das Aufnahmedatum eine Personenangabe. Wer ihn
 *   weglaesst, entscheidet das - hier wird nur weitergereicht.
 */
export function grubenbildStand(bp: AufnahmePunktDocument, datum: string | null): GrubenbildStand {
	const abs = abschnitte(bp.Horizontfolge, bp.Substratfolge);
	const auflage = auflageStreifen(bp.extendedHeader?.humusAuflage);
	const lage = filzLage(bp);
	return {
		abs,
		auflage,
		versatz: lage.versatz,
		daten: {
			abschnitte: abs,
			auflage,
			horizonte: bp.Horizontfolge ?? [],
			substrate: bp.Substratfolge ?? [],
			// Die Kennung, nicht die Messwerte: So bleibt das Bild stabil,
			// waehrend jemand die Aufnahme noch bearbeitet.
			saat: bp._id ?? bp.header?.nummer,
			filz: lage.filz ? { versatz: lage.versatz } : undefined,
			wasser: {
				spiegelTiefe: bp.extendedHeader?.spiegelTiefe,
				saugsaum: bp.extendedHeader?.saugsaum,
				datum,
			},
		},
	};
}
